module.exports = __webpack_public_path__ + "static/img/xmyj.cf8975bf.png";